import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageHeaderComponent {
  @Input() pageName: string;
  @Input() noIcon = false;
  @Input() isAdminPage = false;
}
